export default __webpack_public_path__ + "static/media/cop5.c86c4651.png";